import React from 'react';
import handleViewport from 'react-in-viewport';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import HeroSlider from './HeroSlider';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import Logo from '~/components/Layout/Logo';
import Config from '~/config';
import { setIsTopBannerVisible } from '~/containers/HomePage/actions';
import { default as themeVariables } from '~/shared/themeVariables';
import { makeSelectSliderImage } from '~/containers/HomePage/selectors';

const ViewportHeroSlider = handleViewport(HeroSlider);

const mapStateToProps = createStructuredSelector({
  sliderImages: makeSelectSliderImage(),
});
const mapDispatchToProps = (dispatch) => ({
  setIsTopBannerVisible: (value) => dispatch(setIsTopBannerVisible(value)),
});

@withI18next()
@connect(mapStateToProps, mapDispatchToProps)
class HeroSlideShow extends React.Component {
  renderHeroContent = () => {
    const { t, isAuthenticated, profile } = this.props;

    return (
      <div className="container hero-content">
        <div className="slider-section">
          <h1 className="title-slider">
            {t(Config.getPrefixContent('title_form_search_top_page_seo'))}
          </h1>
          <h2
            className="description-title"
            dangerouslySetInnerHTML={{
              __html: t(Config.getPrefixContent('title2_form_search_top_page')),
            }}
          />
        </div>

        <div className="container text-center">
          {isAuthenticated && profile.role !== Config.getRoles().PREMIUM && (
            <I18nLink href="/premium">
              <a
                className={`btn btn-ac-primary btn-${Config.serviceType} btn-go-premium`}
              >
                {t('go_premium')}
              </a>
            </I18nLink>
          )}
        </div>
        <style jsx>
          {`
            .hero-content {
              z-index: 100;
              position: relative;
              display: flex;
              flex-direction: column;
              justify-content: center;
              color: #fff;
            }

            .slider-section {
              margin: 0 auto;
              margin-top: 50px;
              text-align: center;
            }

            .title-slider {
              font-size: 50px;
              text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
              font-weight: 600;
              padding: 0;
              margin: 0;
            }

            .description-title {
              font-size: 24px;
              margin-top: 20px;
              text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
            }
          `}
        </style>
      </div>
    );
  };

  render() {
    const { sliderImages } = this.props;

    return (
      <div className="hero-container">
        <ViewportHeroSlider
          sliderImages={sliderImages}
          onChangeVisibility={setIsTopBannerVisible}
        />
        {this.renderHeroContent()}
        {Config.isDesignAC() && (
          <div className="overlay-logo">
            <Logo />
          </div>
        )}
        <style jsx>
          {`
            .hero-container {
              position: relative;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              height: 468px;
            }

            .overlay-logo {
              position: absolute;
              top: ${themeVariables.space.half}px;
              left: ${themeVariables.space.base}px;
              background: transparent;
            }
          `}
        </style>
      </div>
    );
  }
}

export default HeroSlideShow;
